import * as React from 'react';
import {createNativeStackNavigator} from '@react-navigation/native-stack';
import RedeemRewards from './childScreens/redeemRewards';
import Rewards from './Rewards';
import EventCreate from './childComponents/eventCreate';
import MarketMaking from './childScreens/MarketMainkg';
import AskX from './childComponents/askx';
import StaticBanner from "./childScreens/StaticBanner";

const Stack = createNativeStackNavigator();

export const RewardsStack = ({storeData}) => {
  return (
    <Stack.Navigator
      screenOptions={({route, navigation}) => ({
        headerShown: false,
        gestureEnabled: true,
      })}>
      <Stack.Screen name="RedeemRewards" component={RedeemRewards} />
      <Stack.Screen name="MarketMaking" component={MarketMaking} />
      <Stack.Screen name="Rewards" component={Rewards} />
      <Stack.Screen name="EventCreate" component={EventCreate} />
      <Stack.Screen name="AskX" component={AskX} />
      <Stack.Screen name="RewardsDetails" component={StaticBanner} />
    </Stack.Navigator>
  );
};
